<div class="ag-grid-search-locations__wrapper">
  <input
    matInput
    class="w-100"
    [placeholder]="formattedSelectedItem"
    [formControl]="searchControl"
    [matAutocomplete]="auto"
  />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySelectedItem">
    <mat-option
      *ngFor="let location of locations; trackBy: trackById"
      [value]="location"
      (click)="selectValue(location)"
    >
      {{ location.location_name }}
    </mat-option>
    <mat-option *ngIf="loadingLocations">
      <mat-progress-spinner
        class="progress-spinner"
        diameter="16"
        mode="indeterminate"
      ></mat-progress-spinner>
    </mat-option>
  </mat-autocomplete>
  <button
    *ngIf="selectedItem && !loadingLocations"
    mat-icon-button
    type="button"
    aria-label="Clear"
    class="clear-button"
    (click)="removeSelectedItem()"
  >
    <mat-icon>close</mat-icon>
  </button>

  <mat-progress-spinner
    *ngIf="loadingLocations"
    class="progress-spinner"
    diameter="16"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>
